/* The ONE intake story (designs/intake-about.md AB6, the only About since
   intake-unified-form.md UF11 cut the per-domain pages). All content comes
   from src/shared/intake-about-module.ts; this file only lays it out.

   No unconfirmed banner here on purpose (AB6-3): this describes behaviour we
   wrote and a process this repo records, so it is confirmed. */
import type { JSX } from "react";
import { INTAKE_ABOUT_MODULE } from "../../../shared/intake-about-module";

export function AboutIntake({
  /* the one call to action: back to the queue, where "+ New effort" lives */
  onStart,
}: {
  onStart?: () => void;
}): JSX.Element {
  const m = INTAKE_ABOUT_MODULE;
  return (
    <div className="about" data-intake-about-module>
      <div className="page-head">
        <h1>How intake works</h1>
        <p>{m.intro}</p>
      </div>

      <h2 className="about-h2">{m.whyHeading}</h2>
      <div className="about-note">
        {m.why.map((par, i) => (
          <p key={i} style={i === m.why.length - 1 ? { marginBottom: 0 } : undefined}>
            {par}
          </p>
        ))}
      </div>

      <h2 className="about-h2">{m.lifecycleHeading}</h2>
      <div className="about-lifecycle" data-about-lifecycle>
        {m.lifecycle.map((stage) => (
          <div key={stage.key} className="about-stage" data-about-stage={stage.key}>
            <h3>{stage.title}</h3>
            <p>{stage.body}</p>
          </div>
        ))}
      </div>

      <h2 className="about-h2">{m.capabilitiesHeading}</h2>
      <div className="cap-list">
        {m.capabilities.map((c) => (
          <div key={c.title} className="cap-block">
            <h3>{c.title}</h3>
            <p className="cap-what">{c.what}</p>
            <p className="cap-why">
              <span className="cap-why-label">Why it helps</span> {c.why}
            </p>
          </div>
        ))}
      </div>

      {onStart !== undefined && (
        <div className="about-cta">
          <button className="btn" onClick={onStart} data-about-start>
            Register an effort →
          </button>
        </div>
      )}
    </div>
  );
}
